<template>
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-header">
                <button class="modal-default-button" @click="$emit('close')">Close</button>
                <div class="modal-title">Add Patient</div>
                
                
              </div>
              <div class="modal-body">

                <form @submit.prevent="addPatient" class="addpatientform">
                  <div>
                    <label>Last Name</label>
                  <input type="text" name="lastname"/>
                  </div>
                  <div>
                    <label>First Name</label>
                  <input type="text" name="firstname"/>
                  </div>
                  <div>
                    <label>Date of Birth</label>
                  <input type="date" name="dateofbirth"/>
                  </div>

                  <div>
                <label>Language</label>
                <select name="preferred_language">
                  <option>English</option>
                  <option>Spanish</option>
                </select>
               </div>
               <div style="text-align:right;">
                <button type="submit" class="addpatientbutton" >Add Patient</button>
               </div>

                </form>



    

    
              </div>
              <div class="modal-footer">
                
                <br/>
                <br/>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template>
    
    
    <script>
    
    export default {
      // Properties returned from data() become reactive state
      // and will be exposed on `this`.
      data() {
        return {


          newItem:{}
        }
      },
      props: ['modaldata'],
      // Methods are functions that mutate state and trigger updates.
      // They can be bound as event handlers in templates.
      methods: {
    
    makeid(length) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      let counter = 0;
      while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
      }
    return result;
},



    addPatient(e) {

 


      var firstname = e.target.elements.firstname.value.toLowerCase();
      var lastname = e.target.elements.lastname.value.toLowerCase();
      var dateofbirth = e.target.elements.dateofbirth.value;
      var preferred_language = e.target.elements.preferred_language.value.toLowerCase();

       this.newItem = {'id':this.makeid(5),'lastname':lastname,'firstname':firstname,'dateofbirth':dateofbirth,'preferred_language':preferred_language}

      //console.log(this.newItem);


       this.$store.dispatch('addPatient',this.newItem)
       this.$emit('close');
    }
    
    
      },
    
      // Lifecycle hooks are called at different stages
      // of a component's lifecycle.
      // This function will be called when the component is mounted.
      mounted() {
        
      },
    
      created() {
     
    
    },
    }
    
    </script>
    
    
    <style lang="scss">
     .addpatientform {
      div {
        margin:20px;
      }
      input {
        height:35px;
        width:200px;
        padding:10px;
      }
      label {
        width:100px;
        display:inline-block;
      }
      select {
        width:100px;
        height:35px;
        padding:5px;
      }
      .addpatientbutton {
        background-color: #55ade1;
        border:0px;
        border-radius:5px;
        width:100px;
        height:35px;
        color:white;
      }
     } 
    
    .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.75);
      display: table;
      transition: opacity 0.3s ease;
    }
    
    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }
    
    .modal-container {
      width: 500px;
      margin: 0px auto;
      padding: 10px 20px;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
      transition: all 0.3s ease;
      text-align:left;
    }
    
    .modal-header {
      font-size:12px;
    }
    
    
    .modal-header .modal-title {
      margin-top: 0;
      font-size:23px;
      font-weight:700;
    }
    
    
    
    
    .modal-body {
      font-size:16px;
      margin: 20px 0;
      line-height:2em;
    
    
    h2 {
      font-size:20px;
      font-weight:700;
      margin:10px 0px 20px 0px;
    }
    
    }
    
    .modal-footer {
      font-size:12px;
    min-height:50px;
    }
    
    
    .modal-default-button {
    float:right;
    background-color:#55ade1;
      margin:0px 10px;
      padding:5px 0px;
      border:0px;
      color:white;
      border-radius:5px;
      width:75px;
      &:hover {
        cursor:pointer;
        filter:brightness(1.1);
      }
    }
    
    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */
    
    .modal-enter {
      opacity: 0;
    }
    
    .modal-leave-active {
      opacity: 0;
    }
    
    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }
    
    
    
    
    </style>